const Navbar = function ($location, $rootScope, $scope, featureToggles, loginInteractor, initialDataInteractor, dataService) {
  const $ctrl = this;
  $ctrl.open = false;

  $scope.featureEnabled = (feature) => featureToggles.isAvailable(feature);

  $ctrl.logout = function () {
    closeDrawer();
    $location.path('/');
    loginInteractor.invalidate();
  };

  $ctrl.userDidClickLogo = function() {
    closeDrawer();
    $location.path($ctrl.isLoggedIn() ? 'dashboard':'');
  };

  $ctrl.navigate = function(path) {
    closeDrawer();
    $location.path(path);
  };

  $ctrl.isLoggedIn = function () {
    return loginInteractor.isLoggedIn();
  };

  $ctrl.userName = function() {
    return dataService.person.name;
  };

  $ctrl.toggleDrawer = function () {
    if ($ctrl.open)
      closeDrawer();
    else
      openDrawer();
  };

  function getElements() {
    return document.getElementsByClassName('drawer');
  }

  function openDrawer() {
    let elements = getElements();
    for(let i=0; i<elements.length; i++) elements[i].classList.remove('drawer-closed');
    setTimeout(() => { // Need a slight offset to ensure browser picks up on animation
      for(let i=0; i<elements.length; i++) elements[i].classList.add('drawer-open');
    }, 10);
    $ctrl.open = true;
  }

  function closeDrawer() {
    let elements = getElements();
    for(let i=0; i<elements.length; i++) elements[i].classList.remove('drawer-open');
    setTimeout(() => {
      for(let i=0; i<elements.length; i++) elements[i].classList.add('drawer-closed');
    }, 300);
    $ctrl.open = false;
  }
};

export default {
  name: 'navbar',
  obj: {
    controller: Navbar,
    templateUrl: 'components/navbar.html'
  },
  deps: []
};
